<template>
  <a-modal width="45%" :title="titlePrefix" :visible="visible" centered :destroy-on-close="true" :mask-closable="false"
    :confirm-loading="confirmLoading" @ok="onSubmit" @cancel="onClose">
    <a-form ref="ruleForm" layout="vertical" :model="form" :rules="rules" @submit="onSubmit">
      <!--可编辑区域 start-->
      <div class="hidden">
        <a-form-item label="id" name="id">
          <a-input v-model:value="form.id" />
        </a-form-item>
      </div>
      <a-form-item label="项目名称" name="projectName">
        <a-input v-model:value="form.projectName" placeholder="请输入" />
      </a-form-item>
      <a-form-item label="职位" name="jobTitle">
        <a-input v-model:value="form.jobTitle" placeholder="请输入" />
      </a-form-item>
      <a-form-item label="项目周期" name="workTime">
        <range-picker style="width: 100%" v-model:startDate="form.startTime" v-model:endDate="form.endTime" />
      </a-form-item>
      <!--可编辑区域 end-->
    </a-form>
  </a-modal>
</template>
<script>
import dataCheck from "@/utils/dataCheck";
import { formMixin } from "@/mixins";
import { projectExpriseInfo } from "@/api/educationService";
import { dateFormat } from "@/config/variableConfig";

export default {
  name: "UserModal",
  components: {},
  mixins: [formMixin],
  data() {
    return {
      dateFormat,
      form: {
        id: null,
      },
      rules: {
        startTime: [],
        endTime: [],
        jobTitle: [dataCheck.required({})],
        projectName: [dataCheck.required({})],
        id: [],
      },
      submitUrl: projectExpriseInfo.saveupdate
    }
  },
}
</script>
<style scoped lang="less"></style>
